import { z } from 'zod';
import { isValidPhoneNumber } from 'libphonenumber-js';

export const profileUpdateSchema = z.object({
  firstName: z.string().min(1, 'First name is required').max(50, 'First name must be less than 50 characters'),
  lastName: z.string().min(1, 'Last name is required').max(50, 'Last name must be less than 50 characters'),
  phone: z.string()
    .optional()
    .or(z.literal(''))
    .refine(
      (val) => !val || val === '' || isValidPhoneNumber(val),
      'Please enter a valid phone number for the selected country'
    )
});

export const emailChangeRequestSchema = z.object({
  newEmail: z.string().email('Invalid email address')
});

export const emailChangeVerifySchema = z.object({
  verificationCode: z.string()
    .length(6, 'Code must be 6 digits')
    .regex(/^\d{6}$/, 'Code must contain only numbers')
});

export const passwordResetRequestSchema = z.object({
  email: z.string().email('Invalid email address')
});

export const passwordResetSchema = z.object({
  newPassword: z.string()
    .min(8, 'Password must be at least 8 characters')
    .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
    .regex(/[0-9]/, 'Password must contain at least one number'),
  passwordConfirmation: z.string()
}).refine(data => data.newPassword === data.passwordConfirmation, {
  message: 'Passwords do not match',
  path: ['passwordConfirmation']
});

export type ProfileUpdateFormData = z.infer<typeof profileUpdateSchema>;
export type EmailChangeRequestFormData = z.infer<typeof emailChangeRequestSchema>;
export type EmailChangeVerifyFormData = z.infer<typeof emailChangeVerifySchema>;
export type PasswordResetRequestFormData = z.infer<typeof passwordResetRequestSchema>;
export type PasswordResetFormData = z.infer<typeof passwordResetSchema>;
